// extracted by mini-css-extract-plugin
export default {"homeBody":"global_homeBody__hzik6","loginBody":"global_loginBody__-G0x2"};